var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "page-tab account-change-container",
      staticStyle: { height: "540px" },
    },
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "form-props": { labelPosition: "left" },
          "layout-mode": "dialog",
          immediate: false,
          "search-schema": _vm.searchSchema,
          columns: _vm.tableColumns,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
        },
        scopedSlots: _vm._u([
          {
            key: "changeAmount",
            fn: function ({ row }) {
              return [
                _c(
                  "span",
                  {
                    class: row.changeAmount.startsWith("-")
                      ? "amount-negative"
                      : "amount-positive",
                  },
                  [_vm._v(" " + _vm._s(row.changeAmount) + " ")]
                ),
              ]
            },
          },
          {
            key: "remark",
            fn: function ({ row }) {
              return [_vm._v(" " + _vm._s(row.remark) + " ")]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }